import React from 'react'

import Header from '../../../../components/header'
import FormFactory from '../../../../components/form/form-factory'
import Modal from '../../../../components/modal'
import ModalContent from './modal-content'

import { Container, Form } from './styles'

import IFormPage from '../../../../interfaces/form-page'

type IProps = IFormPage & {
  isVisible: boolean
  toggleVisibility: (value?: boolean) => void
}

const ChangePassword = ({
  dataForm,
  onSubmit,
  errorMessage,
  isVisible,
  toggleVisibility,
}: IProps) => (
  <Container>
    <Modal
      content={{
        title: 'Senha alterada com sucesso!',
        component: ModalContent,
      }}
      isVisible={isVisible}
      toggleVisibility={toggleVisibility}
    />
    <Header title="Mudar senha" />
    <Form>
      <FormFactory
        data={dataForm}
        onSubmit={onSubmit}
        submitErrorMessage={errorMessage}
      />
    </Form>
  </Container>
)

export default ChangePassword
